import { useUserStore, userStoreSelector } from '@editor/stores/userStore';
import { useGrowthBook } from '@growthbook/growthbook-react';

/**
 * Returns true if growthbook is ready and has set the user attribute (email)
 * @returns boolean
 */
const useIsGrowthbookReady = (): boolean => {
  const growthbook = useGrowthBook();
  const isUserLoaded = useUserStore(userStoreSelector.isUserLoaded);
  const isAnonymousUser = useUserStore(userStoreSelector.isAnonymousUser);

  if (!growthbook) {
    return false;
  }
  const isGrowthbookReady = growthbook.ready;

  const { email } = growthbook?.getAttributes() || {};

  const hasGrowthbookSetEmailAttribute = !!email;

  return (
    isGrowthbookReady &&
    isUserLoaded &&
    (isAnonymousUser ? true : hasGrowthbookSetEmailAttribute)
  );
};

export default useIsGrowthbookReady;
